/**
 * Created by lixueying on 2017/1/16.
 */
import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/utils/bus.js